import api from "./api";

// Capa de servicios API del dominio "VPS" (monitoreo + archivos + acciones + notificaciones)
// (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

// --- Monitoreo ---
export const getVPSStatus = () => api.get("/vps/monitoring/status");
export const getVPSHistory = (days) =>
  api.get(`/vps/monitoring/history?days=${days}`);
export const getVPSThresholds = () => api.get("/vps/monitoring/thresholds");
export const updateVPSThresholds = (payload) =>
  api.put("/vps/monitoring/thresholds", payload);
export const refreshVPSMonitoring = () => api.post("/vps/monitoring/refresh");
export const getVPSDatabaseActivity = () => api.get("/vps/database-activity");
// Tiempo real (Socket.IO) del proceso; se reinicia con cada arranque (doc 0447, D6).
export const getVPSRealtime = () => api.get("/vps/realtime");

// --- Archivos VPS ---
export const getVPSFilesAnalysis = () => api.get("/vps/files/analysis");
export const getVPSFilesList = (fileType, limit) =>
  api.get(`/vps/files/list?type=${fileType}&limit=${limit}`);
// DELETE con body (axios.delete a veces no envía body correctamente).
export const deleteVPSFilesBulk = (payload) =>
  api.request({ method: "DELETE", url: "/vps/files/bulk", data: payload });

// --- Limpieza / acciones ---
// El endpoint (/vps/cleanup/*, /vps/optimize/tables, /vps/monitoring/refresh) lo
// arma el componente según el tipo; siempre es POST.
export const runVPSCleanup = (endpoint, params) => api.post(endpoint, params);
export const getVPSActionJob = (queueId) => api.get(`/vps/actions/job/${queueId}`);
export const getVPSActionHistory = (params) =>
  api.get("/vps/actions/history", { params });

// --- Notificaciones ---
export const getVPSNotificationsConfig = () =>
  api.get("/vps/notifications/config", { timeout: 90000 });
export const saveVPSNotificationsConfig = (payload) =>
  api.post("/vps/notifications/config", payload, { timeout: 120000 });
export const testVPSNotificationEmail = (payload) =>
  api.post("/vps/notifications/test/email", payload);
export const testVPSNotificationWhatsapp = (payload) =>
  api.post("/vps/notifications/test/whatsapp", payload);
export const sendVPSNotificationTest = (payload) =>
  api.post("/vps/notifications/send/test", payload);
